module.exports = __webpack_public_path__ + "static/media/image4.600dba9c.JPG";